export default "__VITE_ASSET__DRxCzl$q__"